import { useEffect, useState } from 'react';

import { getTodayDateString } from '@/util/awaySchedule';

/**
 * Today as a local `YYYY-MM-DD`, advancing itself at local midnight so a screen
 * left open overnight stops treating yesterday's away period as current.
 */
export function useToday(): string {
  const [today, setToday] = useState(() => getTodayDateString());

  useEffect(() => {
    const now = new Date();
    const nextMidnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
    const timer = setTimeout(
      () => setToday(getTodayDateString()),
      nextMidnight.getTime() - now.getTime() + 1000
    );

    return () => clearTimeout(timer);
  }, [today]);

  return today;
}
